export const generateSessionId = (region: string, userId: string): string =>
  `${region}.${userId}`;
